let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("1EybG")).then(() => parcelRequire('2qC1N'));